import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/message_allread.png';
import _imports_1 from '@/assets/image/message_red.png';
const _withScopeId = n => (_pushScopeId("data-v-2aca1a16"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "message"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-right-img",
  src: _imports_0
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-right-text"
}, "全部已读", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = {
  class: "list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "item-left"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "item-unread-img",
  src: _imports_1
};
const _hoisted_10 = {
  class: "item-right"
};
const _hoisted_11 = {
  class: "item-right-top"
};
const _hoisted_12 = {
  class: "item-right-title"
};
const _hoisted_13 = {
  class: "item-right-content"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-right-line"
}, null, -1));
import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { fullScreen, openLoginPage } from '@/utils/navitiveApi/common';
import { getMessageTypeListApi, readApi } from '@/api/message';
export default {
  __name: 'Message',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};

    // import { List } from 'vant';
    const loading = ref(false);
    const finished = ref(true);
    const router = useRouter();
    const isUnread = ref(true);
    const messageList = ref([]);

    //跳转
    const clickItem = message => {
      isUnread.value = false;
      console.log(message);
      router.push({
        path: '/messageList',
        query: {
          title: message.name,
          type: message.type
        }
      });
    };

    //获取数据
    const getData = async () => {
      // $loading.openLoading()
      try {
        const {
          code,
          message,
          data
        } = await getMessageTypeListApi({});
        if (code !== 9000) {
          if (code === 9008) {
            openLoginPage();
          }
          return;
        }
        messageList.value = data.messageTypeList;
      } catch (error) {
        console.error(error);
      }
    };

    //已读
    const allRead = async message => {
      try {
        const {
          code,
          msg
        } = await readApi({
          allReaded: true
        });
        if (code !== 9000) {
          $alert({
            msg
          });
          return;
        }
        getData();
      } catch (error) {
        console.error(error);
      }
    };
    const shouldHideTitleBar = () => {
      return true;
    };
    window['shouldHideTitleBarTest'] = () => {
      return true;
    };
    function abc() {
      return true;
    }
    onMounted(() => {
      fullScreen();
      getData();
      window['shouldHideTitleBar'] = () => {
        return true;
      };
    });
    onUnmounted(() => {
      // alert('onUnmounted')
    });
    return (_ctx, _cache) => {
      const _component_nav_bar = _resolveComponent("nav-bar");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
        title: "消息中心",
        "back-to-close": "",
        isMessage: true
      }, {
        "nav-right": _withCtx(() => [_createElementVNode("div", {
          class: "nav-right",
          onClick: allRead
        }, _hoisted_4)]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
        finished: finished.value,
        "finished-text": ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, message => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: message.type,
            onClick: $event => clickItem(message)
          }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
            class: "item-img",
            src: message.iconUrl
          }, null, 8, _hoisted_8), _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [[_vShow, message.unreadCount > 0]])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(message.name), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(message.latestMsgContent), 1)])]), _hoisted_14])], 8, _hoisted_6);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished"])])]);
    };
  }
};